import React, { useEffect } from "react";

const ContabilidadReportesPage = () => {
  useEffect(() => {
    document.title = "Contabilidad - Reportes | Saas";
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-3">Reportes contables</h4>
            <p className="text-muted mb-0">
              Acá se van a listar los informes básicos de contabilidad: mayor, balance de sumas y saldos,
              estados financieros y exportaciones para auditoría.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContabilidadReportesPage;
